import styled, { css } from 'styled-components';

import { Button, TextareaField } from '@speeki/global-ui-components';

export const EditWrapper = styled.div`
    align-items: flex-end;
    display: flex;
    padding-left: 47px;
    width: 100%;
`;

export const EditMessageField = styled(TextareaField)(
    ({ theme: { palette, radius } }) => css`
        width: 100%;

        textarea {
            background: ${palette.neutral.white};
            border-radius: ${`${radius['8']}px 0 ${radius['8']}px ${radius['8']}px`};
            border: 1px solid ${palette.neutral.darkGrey};
            caret-color: ${palette.primary.default};
            color: ${palette.text.primary};
            min-height: 0;
            outline: none;
            padding: 12px 16px;

            &::placeholder {
                color: ${palette.neutral.white};
            }

            &:focus {
                border: 1px solid ${palette.neutral.darkGrey};
                padding: 12px 16px;
            }
        }
    `,
);

export const EditButton = styled(Button)<{ isError: boolean }>(
    ({ isError }) => css`
        margin-bottom: ${isError ? 25 : 3}px;
        margin-left: 16px;
        transition: background-color 0.5s;
    `,
);
